module.exports = __webpack_public_path__ + "static/img/technology-3.fd6dac6b.png";